var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1837_39792)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_ii_1837_39792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 78.5C159 121.854 123.854 157 80.5 157C37.1456 157 2 121.854 2 78.5C2 35.1456 37.1456 0 80.5 0C123.854 0 159 35.1456 159 78.5ZM80.5 155.461C123.004 155.461 157.461 121.004 157.461 78.5C157.461 35.9957 123.004 1.53922 80.5 1.53922C37.9957 1.53922 3.53922 35.9957 3.53922 78.5C3.53922 121.004 37.9957 155.461 80.5 155.461Z",
    fill: "#77D0D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 78.5C159 121.854 123.854 157 80.5 157C37.1456 157 2 121.854 2 78.5C2 35.1456 37.1456 0 80.5 0C123.854 0 159 35.1456 159 78.5ZM80.5 155.461C123.004 155.461 157.461 121.004 157.461 78.5C157.461 35.9957 123.004 1.53922 80.5 1.53922C37.9957 1.53922 3.53922 35.9957 3.53922 78.5C3.53922 121.004 37.9957 155.461 80.5 155.461Z",
    stroke: "#0F9BB0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1837_39792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 70.2787C33 69.2634 33.823 68.4404 34.8382 68.4404H126.75C127.765 68.4404 128.588 69.2634 128.588 70.2787V81.3081C128.588 82.3233 127.765 83.1463 126.75 83.1463H34.8382C33.823 83.1463 33 82.3233 33 81.3081V70.2787Z",
    fill: "#77D0D1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1837_39792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.3092 28C87.3245 28 88.1476 28.823 88.1476 29.8382V121.75C88.1476 122.765 87.3245 123.588 86.3092 123.588H75.2799C74.2647 123.588 73.4417 122.765 73.4417 121.75V29.8382C73.4417 28.823 74.2647 28 75.2799 28H86.3092Z",
    fill: "#77D0D1"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1837_39792",
    x: 1.5,
    y: -0.5,
    width: 158,
    height: 159.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1837_39792"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1837_39792",
    result: "effect2_innerShadow_1837_39792"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1837_39792",
    x: 33,
    y: 68.4404,
    width: 95.5879,
    height: 16.2061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1837_39792"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1837_39792",
    x: 73.4417,
    y: 28,
    width: 14.7058,
    height: 97.0879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1837_39792"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1837_39792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 160,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMark);
export default __webpack_public_path__ + "static/media/CrossMark.0ae3bba75a3670d479fdb65a60c62010.svg";
export { ForwardRef as ReactComponent };